import { Box } from "@chakra-ui/react";
import TicketsList from "./components/TicketsList";

function Tickets() {
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <TicketsList />
    </Box>
  );
}

export default Tickets;
